import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, useLocation } from 'react-router-dom'
import App from './App'
import { initAnalytics, trackPageview } from './lib/analytics'
import './index.css'

// Google Analytics 4 (no-op until prod / VITE_GA_ID)
initAnalytics()

/** Emits a GA4 page_view on each client-side route change. */
function AnalyticsTracker() {
  const location = useLocation()
  useEffect(() => {
    trackPageview(location.pathname + location.search)
  }, [location.pathname, location.search])
  return null
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AnalyticsTracker />
      <App />
    </BrowserRouter>
  </StrictMode>
)
